const delimiter = /\${([^${};]+)}/gm;

const template = (str: string) => (getValue: (key: string) => string) =>
  str.replace(delimiter, (_, key) => getValue(key));

export default template;
